var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgWhatsNew = function SvgWhatsNew(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26 8c.327 0 .592.224.592.5V13h8.296V8.5c0-.276.265-.5.593-.5.327 0 .592.224.592.5v5c0 .276-.265.5-.592.5H3.259c-.327 0-.592-.224-.592-.5v-5c0-.276.265-.5.592-.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.81c0-.263.244-.477.545-.477h10.91c.3 0 .545.214.545.476V8.19c0 .263-.244.477-.546.477H2.545c-.3 0-.545-.214-.545-.477V5.81Zm1.09.476v1.428h9.82V6.286H3.09Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 5.333c.368 0 .667.229.667.51v7.647c0 .282-.299.51-.667.51-.368 0-.667-.228-.667-.51V5.843c0-.281.299-.51.667-.51Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.407 3.143a.906.906 0 0 0-.628.25.842.842 0 0 0-.26.607c0 .227.093.445.26.606.167.16.393.251.628.251h1.87a4.609 4.609 0 0 0-.278-.582c-.372-.653-.884-1.132-1.592-1.132Zm2.667 2.286.581-.113V5.31l-.003-.009a2.503 2.503 0 0 0-.032-.135 5.993 5.993 0 0 0-.582-1.443C7.596 2.95 6.774 2 5.408 2c-.55 0-1.078.21-1.467.586A1.964 1.964 0 0 0 3.333 4c0 .53.219 1.04.608 1.414.389.375.916.586 1.466.586h2.667a.601.601 0 0 0 .458-.21.556.556 0 0 0 .123-.473l-.58.112Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.962 3.725C8.404 2.95 9.226 2 10.592 2c.55 0 1.078.21 1.467.586.39.375.608.884.608 1.414 0 .53-.219 1.04-.608 1.414A2.114 2.114 0 0 1 10.593 6H7.926a.601.601 0 0 1-.458-.21.556.556 0 0 1-.123-.473l.581.112-.581-.113v-.002l.001-.003.002-.009a2.712 2.712 0 0 1 .033-.135 5.993 5.993 0 0 1 .582-1.443Zm.762 1.132h1.869c.235 0 .462-.09.628-.25a.842.842 0 0 0 .26-.607.842.842 0 0 0-.26-.606.906.906 0 0 0-.628-.251c-.708 0-1.22.479-1.592 1.132a4.61 4.61 0 0 0-.277.582Zm-.217.685Z",
    fill: "currentColor"
  })));
};

export default SvgWhatsNew;